import type {
  CreateViewRequest,
  UpdateViewRequest,
  View,
  ViewListResponse,
  ReorderViewsRequest,
} from '@lens/shared';
import { apiRequest } from '../../shared/api/client.ts';

/**
 * HTTP-обёртки над эндпоинтами `/api/spaces/:id/views/*`.
 * M6. См. docs/api-design.md §4.6.
 */

const base = (spaceId: string) => `/api/spaces/${spaceId}/views`;

export async function listViews(
  spaceId: string,
  itemTypeId?: string,
): Promise<ViewListResponse> {
  const url = itemTypeId
    ? `${base(spaceId)}?itemTypeId=${itemTypeId}`
    : base(spaceId);
  return apiRequest<ViewListResponse>(url, { method: 'GET' });
}

export async function listArchivedViews(spaceId: string): Promise<ViewListResponse> {
  return apiRequest<ViewListResponse>(`${base(spaceId)}?includeArchived=true`, { method: 'GET' }).then(
    (res) => ({ views: res.views.filter((v) => v.isArchived) }),
  );
}

export async function getView(spaceId: string, viewId: string): Promise<View> {
  return apiRequest<View>(`${base(spaceId)}/${viewId}`, { method: 'GET' });
}

export async function createView(
  spaceId: string,
  data: CreateViewRequest,
): Promise<View> {
  return apiRequest<View>(base(spaceId), { method: 'POST', body: data });
}

export async function updateView(
  spaceId: string,
  viewId: string,
  data: UpdateViewRequest,
): Promise<View> {
  return apiRequest<View>(`${base(spaceId)}/${viewId}`, {
    method: 'PATCH',
    body: data,
  });
}

export async function deleteView(spaceId: string, viewId: string): Promise<void> {
  await apiRequest<void>(`${base(spaceId)}/${viewId}`, { method: 'DELETE' });
}

export async function duplicateView(
  spaceId: string,
  viewId: string,
): Promise<View> {
  return apiRequest<View>(`${base(spaceId)}/${viewId}/duplicate`, {
    method: 'POST',
  });
}

export async function reorderViews(
  spaceId: string,
  data: ReorderViewsRequest,
): Promise<ViewListResponse> {
  return apiRequest<ViewListResponse>(`${base(spaceId)}/reorder`, {
    method: 'POST',
    body: data,
  });
}
